export default __webpack_public_path__ + "static/media/itau-logo-white.0dd924e8.webp";